module.exports = __webpack_public_path__ + "6dfb34e52c7e3e6ee21e0850aa818411.svg";